export interface ThreeShapeUrlInput {
  clinicId: string;
  treatmentId?: string;
  referralId?: string;
  action?: string;
}

export interface ThreeShapeUrlResponse {
  authUrl: string;
  endSessionUrl: string;
}

export interface ThreeShapeSuggestion {
  id: string;
  patientName: string;
  patientId: string;
  creationDate: string;
  shortComment: string;
  downloadUrl?: string;
}

export interface ThreeShapeCase {
  id: string;
  patientName: string;
  orderNumber: string;
  createdAt: Date;
  description: string;
  attachments: string[];
}

export interface ThreeShapeCasesInput {
  clinicId: string;
  searchParams?: string;
  pageNumber: number;
}

export interface ThreeShapeCasesResponse {
  edges: ThreeShapeCase[];
  hasNext: boolean;
}

export interface ThreeShapeCaseFilesDownloadLinkResponse {
  presignedUrl: string;
}

export enum ThreeShapeExportAction {
  DOWNLOAD_SCANS = 'DOWNLOAD_SCANS',
  UPLOAD_SCANS = 'UPLOAD_SCANS'
}

export interface ExportThreeShapeScansInput {
  caseId: string;
  treatmentId?: string;
  referralId?: string;
  attachments: string[];
  action: ThreeShapeExportAction;
}

export interface ExportThreeShapeScansResponse {
  presignedUrl?: string;
  isTriggered: boolean;
}
